import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useLocalStorage } from 'hooks/useStorage'
import { useRouteMatch } from 'react-router'

import { AtividadeColetivaGruposFormModel } from '../model-atividadeColetivaGrupos'

export const useAtividadeColetivaGruposCache = () => {
  const { acesso } = useAcessoLotacaoOrEstagio()
  const match = useRouteMatch()

  const [getCachedValue, setCachedValue, clearCachedValue] = useLocalStorage<AtividadeColetivaGruposFormModel>(
    `${acesso.id}/${match.url}`
  )

  return { cachedValue: getCachedValue(), setCachedValue, clearCachedValue }
}
